// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import campaignCandidateEntity from './entities/campaign-candidate.json';
import campaignCandidateMenu from '../pages/campaign-candidate/menu.json';
import campaignCandidateFullForm from '../pages/campaign-candidate/forms/full.json';
import campaignCandidateContextForm from '../pages/campaign-candidate/forms/context.json';
import campaignCandidateMiniForm from '../pages/campaign-candidate/forms/mini.json';
import campaignCandidateLookupForm from '../pages/campaign-candidate/forms/lookup.json';
import campaignCandidateTableView from '../pages/campaign-candidate/views/table.json';
import campaignCandidateCardsView from '../pages/campaign-candidate/views/cards.json';
import campaignCandidateDashboardView from '../pages/campaign-candidate/views/dashboard.json';

/** Тип запису «Кандидат» зі сторінками пакета: меню, форми та подання з pages/campaign-candidate/. */
export const campaignCandidateDefinition: IRecordTypeDefinition = {
  ...campaignCandidateEntity,
  views: assembleViewSet({
      table: campaignCandidateTableView,
      cards: campaignCandidateCardsView,
      dashboard: campaignCandidateDashboardView,
  }),
  form: campaignCandidateFullForm,
  forms: { full: campaignCandidateFullForm, context: campaignCandidateContextForm, mini: campaignCandidateMiniForm, lookup: campaignCandidateLookupForm },
  menu: campaignCandidateMenu,
} as IRecordTypeDefinition;
